import React, { useState, useRef } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  font-size: 18px;
  overflow-y: hidden;
  padding: 15px 20px 15px 20px;
  background: white;
`

const Title = styled.div`
  font-weight: bold;
  display: flex;
  user-select: none;
  justify-content: space-between;
  padding-right: 40px;
  line-height: 1.2;
  cursor: pointer;
`

const Content = styled.div`
  max-height: ${(props: { active: boolean, height: number }) => props.active ? `${props.height}px` : '0'};
  opacity: ${(props: { active: boolean, height: number }) => props.active ? 1 : 0};
  margin-top: ${(props: { active: boolean, height: number }) => props.active ? '10px' : '0'};
  transition: all 0.5s;
  line-height: 24px;
`

const Arrow = styled.div`
  position: absolute;
  right: 20px;
  top: 16px;
  transform: ${(props: { flipped: boolean }) => props.flipped ? `rotate(180deg)` : ''};
  transition: transform 0.5s;
  width: 36px;
  height: 20px;
  span {
    position: absolute;
    height: 2px;
    background-color: black;
    width: 18px;
    bottom: 0;
  }
  > :nth-child(1) {
    left: 0;
    transform: rotate(45deg);
    transform-origin: 100% 100%;
  }
  > :nth-child(2) {
    right: 0;
    transform: rotate(-45deg);
    transform-origin: 0% 100%;
  }
`

const Drawer = ({ title, children }: { title: string, children: any }) => {
  const [active, setActive] = useState(false)
  const [height, setHeight] = useState(0)
  const content = useRef(null);

  const open = () => {
    setActive(!active)
    if (content && content.current) {
      setHeight(
        content.current.scrollHeight
      )
    }
  }

  return <Wrapper>
    <Title onClick={open}>
      <div>{ title }</div>
      <Arrow flipped={active}><span/><span /></Arrow>
    </Title>
    <Content ref={content} active={active} height={height}>
      { children }
    </Content>
  </Wrapper>
}

export default Drawer
